import { IApiServiceContext, ApiServiceContextState } from '../context/ApiServiceContext';
import { useContext } from 'react';
import {ISettingsContext, SettingsContextState} from "../context/SettingsContext";
import ThemeContext, {IThemeContext, IThemeContextState} from "../context/ThemeContext";

export const useUITheme = () => useContext<IThemeContextState>(IThemeContext)